import React, { useState, useEffect, Fragment } from 'react';
import TextInput from '../TextInput/TextInput';
import InputAdornment from '@material-ui/core/InputAdornment';
import SvgIcon from '@material-ui/core/SvgIcon';
import moment from 'moment';
import DateRangeRoundedIcon from '@material-ui/icons/DateRangeRounded';
import EventRoundedIcon from '@material-ui/icons/EventRounded';

const DatePickerInput = (inputProps, configProps) => {
  const props = { ...inputProps, ...configProps };
  const [hasError, setHasError] = useState(false);
  const [inputValue, setInputValue] = useState(props.value);
  const [announceText, setAnnounceText] = useState('');

  useEffect(() => {
    setInputValue(props.value);
  }, [configProps.value]);

  const validateDateValue = value => {
    if (value && !moment(value, props.dateFormat, true).isValid()) {
      return false;
    }
    return true;
  };

  const handleOnChange = event => {
    const value = event.target.value;
    setInputValue(value);
    if (value === '') {
      return props.clearDate();
    }
  };

  const handleOnBlur = () => {
    setAnnounceText('');
    if (validateDateValue(inputValue)) {
      props.onChange({ target: { value: inputValue } });
    } else {
      if (props.datePickerRef.current.state.open === false) {
        props.datePickerRef.current.setOpen(true);
      }
    }
    if (!validateDateValue(inputValue)) {
      return setHasError(true);
    }
    return setHasError(false);
  };

  const handleOnFocus = () => {
    if (props.showFullMonthYearPicker) {
      setAnnounceText(
        'Use the tab, up/down and enter key to select the desired year, use the tab key to focus the desired month and enter key to select the focused month from the month picker',
      );
    } else {
      setAnnounceText(
        'Use the left/right arrow key to select the desired date from the date picker. Use the up/down arrow key to select the desired week from the date picker. Use the page up/page down key to select the desired month from the date picker. Use the home/end key to select the desired year from the date picker.',
      );
    }
  };

  const { classes, label, required, placeholder, event, dateRange, errorText, onClick } = props;
  const { id, name } = inputProps;

  return (
    <Fragment>
      <TextInput
        type="text"
        label={label || 'Choose a date'}
        required={!!required}
        placeholder={placeholder || 'Choose a date'}
        styleType={'date'}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end" classes={{ root: classes ? classes.iconRoot : '' }}>
              {event || dateRange ? (
                event ? (
                  <EventRoundedIcon />
                ) : (
                  <DateRangeRoundedIcon />
                )
              ) : (
                <SvgIcon>
                  <path
                    fill="#2E2E38"
                    d="M19,19H5V8H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3H18V1"
                  />
                </SvgIcon>
              )}
            </InputAdornment>
          ),
        }}
        hasError={props.hasError ? props.hasError : hasError}
        errorText={errorText || 'Please enter a valid date.<br />Example: 01 Mar 2019'}
        {...configProps}
        id={id}
        name={name || 'text'}
        // all the on event are defined after config props because
        // it also contains this functions which are going to overwrite by the below event handlers
        onFocus={handleOnFocus}
        value={inputValue}
        onChange={handleOnChange}
        onClick={onClick}
        onBlur={handleOnBlur}
      />
      <div className="announce-message" aria-live="polite">
        {announceText}
      </div>
    </Fragment>
  );
};

export default DatePickerInput;
